import { BrandColors } from '../theme';

export const toggleswitchTokens = {
    root: {
        width: '3rem',
        height: '1.5rem',
        borderRadius: '2rem',
        background: BrandColors.surface[300],
        hoverBackground: BrandColors.surface[400],
        checkedBackground: BrandColors.primary[100],
        checkedHoverBackground: BrandColors.primary[600],
        disabledBackground: BrandColors.surface[100],
        borderColor: 'transparent',
        checkedBorderColor: 'transparent',
        focusRing: {
            color: BrandColors.primary[300],
        }
    },
    colorScheme: {
        light: {
            root: {
                checkedBackground: BrandColors.primary[100],
            },
            handle: {
                background: BrandColors.gray[900],
                hoverBackground: BrandColors.gray[950],
                checkedBackground: BrandColors.primary[500],
                checkedHoverBackground: BrandColors.gray[200]
            }
        }
    }
};
